/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import type { ComponentChildren, RefObject } from 'preact';
import { panZoomLayoutStyles } from './themes/TimeComponentStyles.css';
import { classNames } from '#utils/UNSAFE_classNames';
import { TimeComponentLayersStack } from './TimeComponentLayersStack';
import { TimeComponentOverlayControlsContainer } from './TimeComponentOverlayControlsContainer';
import { Size } from '#utils/UNSAFE_size';

type Props = {
  overlayControlsContainerRef: RefObject<HTMLDivElement>;
  width?: Size;
  height?: Size;
  overlayControls?: ComponentChildren;
  verticalControl?: ComponentChildren;
  verticalControlTopGap?: string;
  verticalControlBottomGap?: string;
  verticalControlStartGap?: boolean;
  horizontalControl?: ComponentChildren;
  horizontalControlStartGap?: string;
  horizontalControlEndGap?: string;
  horizontalControlTopGap?: boolean;
  vis: ComponentChildren;
};

export function TimeComponentPanZoomLayout({
  overlayControlsContainerRef,
  width,
  height,
  overlayControls,
  verticalControl,
  verticalControlTopGap = '0',
  verticalControlBottomGap = '0',
  verticalControlStartGap = true,
  horizontalControl,
  horizontalControlStartGap = '0',
  horizontalControlEndGap = '0',
  horizontalControlTopGap = true,
  vis
}: Props) {
  return (
    <div
      class={panZoomLayoutStyles.base}
      style={{
        gridTemplateColumns: `${horizontalControlStartGap} minmax(0, 1fr) ${horizontalControlEndGap} auto`,
        gridTemplateRows: `${verticalControlTopGap} minmax(0, 1fr) ${verticalControlBottomGap} auto`,
        width,
        height
      }}>
      <div
        class={classNames([
          panZoomLayoutStyles.verticalControl,
          verticalControlStartGap && panZoomLayoutStyles.verticalControlWithSpacing
        ])}>
        {verticalControl}
      </div>
      <div
        class={classNames([
          panZoomLayoutStyles.horizontalControl,
          horizontalControlTopGap && panZoomLayoutStyles.horizontalControlWithSpacing
        ])}>
        {horizontalControl}
      </div>
      <div class={panZoomLayoutStyles.vis}>
        {overlayControls ? (
          <TimeComponentLayersStack>
            {vis}
            <TimeComponentOverlayControlsContainer innerRef={overlayControlsContainerRef}>
              {overlayControls}
            </TimeComponentOverlayControlsContainer>
          </TimeComponentLayersStack>
        ) : (
          vis
        )}
      </div>
    </div>
  );
}
